require('./brokerTransferPensionPlansExternalStep4.scss');

const PropTypes = require('prop-types');

// @vendors
const React = require('react');
const { FormattedText, formatText } = require('core/i18n').i18n;

//@ Utilities

// @Components
const { OKBoxTitle } = require('commonsComponents/OKBoxTitle');
const { SignaturePattern } = require('components/signaturePattern/signaturePattern');
const BrokerTransferPensionPlansDataSummary = require('components/commons/broker/brokerTransferPensionPlansDataSummary/brokerTransferPensionPlansDataSummary');
const { BrokerPlanLegalDocumentDisclaimer } = require('components/broker/brokerPlanLegalDocumentDisclaimer/brokerPlanLegalDocumentDisclaimer');

// @Constants
const {
    BROKER_TRANSFER_PENSION_PLAN_EXTERNAL
} = require('constants/operationTypes');
const {
    API_CENTER,
    API_ENTERPRISE_NUMBER
} = require('constants/index');

class BrokerTransferPensionPlansExternalStep4 extends React.Component {

    constructor(props) {
        super(props);

        this.handleToggleDisclaimer = this.handleToggleDisclaimer.bind(this);
    }

    handleToggleDisclaimer() {
        const { toggleDisclaimer } = this.props;
        toggleDisclaimer();
    }

    buildTransferSummary() {
        const {
            immStep1,
            immStep2,
            immStep3
        } = this.props;

        const options = {
            planInWallet: immStep2.get('planFromWallet'),
            selectedTypeOption: immStep3.get('selectedTypeOption'),
            selectedFiscOption: immStep3.get('selectedFiscOption'),
            partialAportation: immStep3.get('partialAportation')
        }

        const originPlan = immStep1.get('originPlanData');
        const destinationPlan = immStep2.get('destinationPlanData');

        return (
            <BrokerTransferPensionPlansDataSummary
                originPlanData={originPlan}
                isExternalTransfer={true}
                destinationPlanData={destinationPlan}
                options={options} />
        );
    }

    buildLegalDisclaimer() {
        const {
            immStep2,
            immStep4
        } = this.props;
        const destinationPlanData = immStep2.get('destinationPlanData');

        const disclaimer = (
            <div className="broker-transfer-pension-plans-external-step4__legal-disclaimer">
                <BrokerPlanLegalDocumentDisclaimer
                    disclaimerErrorState={immStep4.get('disclaimerInvalid')}
                    disclaimerErrorMessage={formatText('brokerTraspassBetweenMyPlans-brokerTraspassBetweenMyPlans_disclaimerError')}
                    disclaimerChecked={immStep4.get('disclaimerChecked')}
                    onDisclaimerCheckChange={this.handleToggleDisclaimer}
                    planName={destinationPlanData.get('name')}
                    planDgsCode={destinationPlanData.get('DGSCode')}
                    planSecId={destinationPlanData.getIn(['comercialData', 'SecId'])} />
            </div>
            )

        return disclaimer;
    }

    buildOTPConfirm() {
        const {
            immStep2
        } = this.props;

        const destinationAccountContractNumber = immStep2.getIn(['destinationPlanData', 'associatedAccount', 'contractNumber']);
        const destinationAccountProductNumber = immStep2.getIn(['destinationPlanData', 'associatedAccount', 'productId']);

        const operationParams = {
            destinationAccount: `${API_ENTERPRISE_NUMBER}${API_CENTER}${destinationAccountProductNumber}${destinationAccountContractNumber}`
        }

        return (
            <div className="broker-transfer-pension-plans-external-step4__otp-confirm">
                <div className="broker-transfer-pension-plans-external-step4__info">
                    <FormattedText value="brokerTraspassBetweenMyPlans-brokerTraspassBetweenMyPlans_step4OTPRequest" />
                </div>
                <SignaturePattern
                    operationType={BROKER_TRANSFER_PENSION_PLAN_EXTERNAL}
                    operationParams={operationParams}
                    isWealth={true}
                />
            </div>
        )
    }

    render(){

        return (
            <div className="broker-transfer-pension-plans-external-step4">
                <OKBoxTitle
                    className="broker-transfer-pension-plans-external-step4__title"
                    value={formatText('brokerTraspassBetweenMyPlans-brokerTraspassBetweenMyPlans_step4Title')} />
                <div className="broker-transfer-pension-plans-external-step4__info">
                    <FormattedText value="brokerTraspassBetweenMyPlans-brokerTraspassBetweenMyPlans_step4Info" />
                </div>
                <div className="broker-transfer-pension-plans-external-step4__summary">
                    {this.buildTransferSummary()}
                </div>
                {this.buildLegalDisclaimer()}
                {this.buildOTPConfirm()}
            </div>
        )
    }
}

BrokerTransferPensionPlansExternalStep4.propTypes = {
    immProfile: PropTypes.object.isRequired,
    immStep1: PropTypes.object.isRequired,
    immStep2: PropTypes.object.isRequired,
    immStep3: PropTypes.object.isRequired,
    immStep4: PropTypes.object.isRequired,
    toggleDisclaimer: PropTypes.func.isRequired
}

module.exports = BrokerTransferPensionPlansExternalStep4;
